var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"actions flex"},[_c('button',{staticClass:"mr-2",on:{"click":function($event){return _vm.min()}}},[_vm._v("-")]),_c('button',{on:{"click":function($event){return _vm.plus()}}},[_vm._v("+")])])}
var staticRenderFns = []

export { render, staticRenderFns }